<template>
  <div>
    <Header></Header>
    <div class="exam-wrapper">
      <div class="pro_header">
        <div class="modal_class">
          <div @click="onClickLeft" class="back_class">
            <img src="../../assets/img/fanhui.png" style="margin-right: 12px;width: 20px;height: 20px;" />
            <div>返回</div>
          </div>
          <div style="margin-left: 15px;" class="title_class">
            {{ detail.title }}
          </div>
        </div>
      </div>
      <div class="introduction_wrap">
        <div class="wrap_top">
          <div style="width: 228px;">
            <img src="../../assets/img/shiti.png" />
          </div>
          <div class="top_text">
            <div class="title">{{ detail.title }}</div>
            <div class="middle_text">
              <span>作答时长：{{ detail.totalTime }}分钟</span>
              <span>总分：{{ detail.totalScore }}分</span>
            </div>
            <div class="middle_text">
              <span>试卷类型：<i v-if="detail.isFormal == 2">米诺测试</i><i v-else>专题测试</i></span>
              <span>出卷机构：中税网</span>
            </div>
            <div class="answer_btn" @click="startapper(detail)">
              开始答题
            </div>
          </div>
        </div>
        <el-divider style="color: #F0F0F0;"></el-divider>
        <div class="introduce_wrap">
          <div class="introduce_title">题型介绍</div>
          <el-empty v-if="!detail.quType1 || detail.quType1 == null || detail.quType1 == undefined"
            description="暂无题型介绍"></el-empty>
          <div class="step_class" style="margin-top: 18px;" v-else>
            <el-steps direction="vertical">
              <el-step v-if="detail.quType1" :title="detail.quType1" :description="detail.quTypeIntroduction1">
                <template #icon>
                  <div class="icon_wrap">
                    <div class="icon_inner"></div>
                  </div>
                </template>
              </el-step>
              <el-step v-if="detail.quType2" :title="detail.quType2" :description="detail.quTypeIntroduction2">
                <template #icon>
                  <div class="icon_wrap">
                    <div class="icon_inner"></div>
                  </div>
                </template>
              </el-step>
              <el-step v-if="detail.quType3" :title="detail.quType3" :description="detail.quTypeIntroduction3">
                <template #icon>
                  <div class="icon_wrap">
                    <div class="icon_inner"></div>
                  </div>
                </template>
              </el-step>
              <el-step v-if="detail.quType4" :title="detail.quType4" :description="detail.quTypeIntroduction3">
                <template #icon>
                  <div class="icon_wrap">
                    <div class="icon_inner"></div>
                  </div>
                </template>
              </el-step>
              <el-step v-if="detail.quType5" :title="detail.quType5" :description="detail.quTypeIntroduction3">
                <template #icon>
                  <div class="icon_wrap">
                    <div class="icon_inner"></div>
                  </div>
                </template>
              </el-step>
            </el-steps>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import Header from "./components/Header.vue";
import Header from "@/components/Header.vue";
import { getExam } from '@/api/apper.js'
export default {
  name: 'exam',
  components: { Header },
  data() {
    return {
      id: '',
      detail: {},
      token: '',
      specId: '',
    }
  },
  created() {
    this.id = this.$route.params.id
    this.token = window.localStorage.getItem('token')
    this.specId = this.$route.query.ksid
    localStorage.setItem('specId', this.specId)
    this.getExamFun()
  },
  methods: {
    getExamFun() {
      getExam({ id: this.id }, { Authorization: this.token }).then(res => {
        if (res.code == 200) {
          this.detail = res.data
        }
      })
    },
    startapper: function (item) {
      this.$router.push('/apper?apperId=' + this.id + '&chaName=' + this.detail.title)
    },
    onClickLeft: function () {
      if (this.specId == -1) {
        // this.$router.push('/')
        this.$router.go(-1)
      } else {
        this.$router.push(`/ztDetails/${this.specId}`)
      }
    },
  }
}
</script>

<style lang="less" scoped>
.exam-wrapper {
  width: 1200px;
  margin: 0 auto;
  margin-top: 120px;
}

.pro_header {
  width: 100%;
  margin-top: 25px;

  .modal_class {
    padding-left: 35px;
    display: flex;
    height: 68px;
    line-height: 68px;
    background: #FFFFFF;
    border-radius: 8px;
    border: 1px solid #F0F0F3;

    .back_class {
      min-width: 72px;
      font-size: 20px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #666666;
      cursor: pointer;
      display: flex;
      align-items: center;
    }

    .title_class {
      font-size: 22px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #666666;
      padding-right: 20px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
}

.introduction_wrap {
  // width: 100%;
  min-height: calc(100vh - 220px);
  margin-bottom: 20px;
  margin-top: 10px;
  // min-height: 730px;
  padding: 0 45px;
  background: #FFFFFF;
  border-radius: 8px;
  border: 1px solid #EAEAEA;
  // background-color: aqua;
  display: flex;
  flex-direction: column;
  align-items: center;

  .wrap_top {
    min-width: 790px;
    margin-top: 25px;
    display: flex;
    width: 100%;

    .top_text {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      margin-top: 15px;
      flex: 1;

      .title {
        font-size: 22px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #333333;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .middle_text {
        span {
          display: inline-block;
          width: 180px;
          font-size: 20px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;

          &:last-child {
            margin-left: 100px;
          }

          i {
            font-style: normal;
          }
        }
      }

      .answer_btn {
        width: 108px;
        height: 44px;
        background: #3E63EE;
        border-radius: 6px;
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 42px;
        text-align: center;
        cursor: pointer;
      }
    }
  }

  .introduce_wrap {
    width: 100%;

    .introduce_title {
      font-size: 22px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
    }

    .step_class {
      .icon_wrap {
        width: 18px;
        height: 18px;
        background: #FFFFFF;
        border: 1px solid #979797;
        border-radius: 9px;
        position: relative;

        .icon_inner {
          width: 10px;
          height: 10px;
          background: #979797;
          border-radius: 5px;
          position: absolute;
          // margin-top: 3px;
          // margin-left: 3px;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
      }

      ::v-deep(.el-step__title.is-process) {
        font-size: 18px;
        font-weight: 600;
        color: #303B45;
      }

      ::v-deep(.el-step__description.is-process) {
        font-size: 16px;
        font-weight: 400;
        color: #666666;
        margin-top: 8px;
        // margin-bottom: 25px
      }

      ::v-deep .el-step__description {
        margin-bottom: 16px;
      }

      ::v-deep .el-step__title.is-wait {
        font-size: 16px;
        font-weight: 600;
        color: #333;
      }

      ::v-deep .el-step.is-vertical {
        height: 100px;
      }

      ::v-deep .el-step__description.is-wait {
        font-size: 14px;
        font-weight: 400;
        color: #666666;
        /* margin-top: 8px; */
      }
    }
  }
}
</style>